import * as React from "react"
import { useRef } from "react"
import { IconButtonSeeker } from "ui-seeker/core"

import OutsideAlerter from "app/components/modals/useOutsider"
import { useAppCalendarEventsActions } from "../@hooks";

export const eventsStatus = (level) => {
    const status = [
        'Low relevance',
        'Low relevance',
        'Medium relevance',
        'High relevance'
    ]

    return status[level] || status[0]
}

export default function AppCalendarEventsAction({ date }) {

    const { dayEvents, isOpen, setIsOpen, deleteEvent } = useAppCalendarEventsActions(date)
    const buttonRef = useRef(null)

    if(dayEvents.length === 0) return null

    return <div style={{ overflow: 'visible', position: 'relative' }} className="calendar-icons">
        <div ref={buttonRef} >
            <IconButtonSeeker className='event-icon' icon="calendar-check" iconType="fontAwesome" onClick={() => setIsOpen(true)} />
        </div>
        { isOpen && buttonRef.current && <div className="events-panel">
            <span className="triangle-arrow" />
            <OutsideAlerter 
                open={isOpen} 
                setOpen={setIsOpen} 
                parentRef={buttonRef}
                modalWidth={300}
                modalHeight={200}
                placement={"bottom"}
                align={"end"}
                offsetTop={-130}
            >
                { dayEvents.map((e, i) => {
                    return <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <div style={{ width: '80%' }} key={e.id_event} className="text-align-left">
                            <span style={{ color: 'var(--text-body)', fontWeight: 'bold' }}>{ e.name }</span><br />
                            <span style={{ color: 'var(--text-muted)' }}>{ eventsStatus(e.level) }</span>
                        </div>
                        <div style={{ width: '20%' }}>
                            <IconButtonSeeker style={{ width: '40px', marginRight: 0 }} icon="trash-alt" iconType="fontAwesome" title="Remove event" onClick={() => deleteEvent(e.id_event)} tooltipPosition='left'/>
                        </div>
                    </div>
                }) }
            </OutsideAlerter>
        </div>}
    </div>
}